<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Nuevo coacreedor
        </div>
      </div>
      <div class="card-body pb-5">
        <hr class="mt-4"/>
        <!--begin: Beneficiary Create -->
          <sys-form :inputs.sync="beneficiary_create"/>
        <!--end: Beneficiary Create -->
        <hr class="mt-4"/>
        <!--begin: Fiscal Info -->
          <div class="row mt-4">
              <div class="col-sm col-md col-lg">
                  <h4 class="m--font-info">Datos bancarios</h4>
              </div>
          </div>
          <sys-form :inputs="beneficiary_bank_account"/>
        <!--end: Fiscal Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import banksService from '@/services/banks'
import contractsService from '@/services/contracts'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'BeneficiaryCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      beneficiary_create: {
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido paterno',
          hint: 'Apellido paterno',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido materno',
          hint: 'Apellido materno',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text',
          size: 4
        },
        email: {
          name: 'Correo eléctronico',
          hint: 'Correo eléctronico',
          value: '',
          type: 'email',
          size: 4
        },
        dob: {
          name: 'Fecha de nacimiento',
          hint: 'Fecha de nacimiento',
          value: '',
          type: 'date',
          size: 4
        },
        percentage: {
          name: 'Porcentaje',
          hint: 'Porcentaje',
          value: '',
          type: 'number',
          size: 4,
          validate: 'required'
        },
        investor_account: {
          name: 'Datos bancarios',
          hint: 'Agregar nueva cuenta bancaria',
          value: null,
          type: 'select',
          size: 4,
          options: []
        },
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text'
        },
        clave_id: {
          name: 'Clave Dispersión',
          hint: 'Id para Pagos',
          value: '',
          type: 'text'
        },
        zip: {
          name: 'Código Postal',
          hint: 'C.P.',
          value: '',
          type: 'number'
        },
        street: {
          name: 'Calle',
          hint: 'Calle',
          value: '',
          type: 'text'
        },
        number: {
          name: 'Número ext./int.',
          hint: 'Número ext./int.',
          value: '',
          type: 'number',
          min: 0,
          max: 9999
        },
        neighborhood: {
          name: 'Colonia',
          hint: 'Colonia',
          value: '',
          type: 'text'
        },
        city: {
          name: 'Municipio',
          hint: 'Municipio',
          value: '',
          type: 'text'
        },
        state: {
          name: 'Estado',
          hint: 'Estado',
          value: '',
          type: 'text'
        }
      },
      beneficiary_bank_account: {
        holder: {
          name: 'Cuentahabiente',
          hint: 'Cuentahabiente',
          value: '',
          type: 'text',
          size: 6
        },
        bank_id: {
          name: 'Banco',
          hint: 'Seleccione un banco',
          value: null,
          type: 'select',
          size: 6,
          options: []
        },
        account: {
          name: 'Número de cuenta',
          hint: 'Número de cuenta',
          value: '',
          type: 'number',
          size: 6,
          validate: 'isBankAccount'
        },
        clabe: {
          name: 'CLABE',
          hint: 'CLABE',
          value: '',
          type: 'number',
          size: 6,
          validate: 'isClabe'
        }
      },
      bank_accounts: {}
    }
  },

  created: function () {
    banksService.list().then(res => {
      this.beneficiary_bank_account.bank_id.options = res.map(bank => {
        return { value: bank.id, text: bank.name }
      })
    })
    let contractId = this.$route.params.id
    contractsService.getById(contractId).then(res => {
      investorsService.getById(res.data.investor_id).then(investor => {
        if (investor.data.bank_data.length > 0) {
          this.beneficiary_create.investor_account.options = this.bank_accounts = investor.data.bank_data.map(bankAccount => {
            return { value: bankAccount.bank_id, text: `${bankAccount.bank} (********${bankAccount.account.substr(-4)})`, account: bankAccount.account, holder: bankAccount.holder, clabe: bankAccount.clabe, bank: bankAccount.bank }
          })
        }
      })
    })
    this.beneficiary_create.investor_account.value = { value: '', text: 'Agregar nueva cuenta bancaria' }
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.beneficiary_create)
          let bankAccountData = this.processForm(this.beneficiary_bank_account)
          if (Object.keys(bankAccountData).length) body['bank_account_data'] = bankAccountData
          let contractId = this.$route.params.id

          contractsService.postBeneficiary(contractId, body).then(res => {
            if (res.error) {
              console.log(JSON.stringify(res.error))
              alert(res.error.message)
            } else {
              this.$router.push({ name: 'contract', params: { id: contractId } })
            }
          }).catch(err => {
            if (err) {
              console.log(JSON.stringify(err.statusText))
              alert(err.statusText)
            }
          })
        }
      })
    }
  },

  watch: {
    'beneficiary_create.investor_account.value': function (newValue, oldValue) {
      if (newValue == null || newValue.value == '') {
        this.beneficiary_bank_account.holder.value = ''
        this.beneficiary_bank_account.bank_id.value = ''
        this.beneficiary_bank_account.account.value = ''
        this.beneficiary_bank_account.clabe.value = ''
      } else {
        this.bank_accounts.map(account => {
          if (account.value == newValue.value) {
            this.beneficiary_bank_account.holder.value = account.holder
            this.beneficiary_bank_account.bank_id.value = { value: account.value, text: account.bank }
            this.beneficiary_bank_account.account.value = account.account
            this.beneficiary_bank_account.clabe.value = account.clabe
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/beneficiaries/BeneficiaryCreate.vue